/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询我的收藏项目
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetCollectProjectListParams {
  constructor(public pageNum: number, public pageSize: number) {}
}

export default async function (
  params: GetCollectProjectListParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.Page<member.CollectProjectRes>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/collections`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
